import React, { useEffect, useState } from "react";
import axios from "axios";
import Slider from "react-slick";
import "./TrustSection.css";
 
import FiverrLogo from "../../assets/contact/fiverr.svg";
import UpworkLogo from "../../assets/contact/upwork.svg";
import PeoplePerHourLogo from "../../assets/contact/peopleperhour.svg";
import StarIcon from "../../assets/contact/star.svg";
import ClientAvatar from "../../assets/contact/client-avatar.png"; // fallback
 
const TrustSection = () => {
  const [testimonials, setTestimonials] = useState([]);
 
  useEffect(() => {
    const fetchTestimonials = async () => {
      try {
        const res = await axios.get("https://api.web-bunny.com/testimonials");
        if (res.status === 200) {
          const data = res.data;
          setTestimonials(Array.isArray(data) ? data : [data]);
        }
      } catch (err) {
        console.error("Failed to fetch testimonials:", err);
      }
    };
 
    fetchTestimonials();
  }, []);
 
  // Slider settings
  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 5000,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    arrows: false,
    centerMode: false,
  };
 
  return (
    <section className="trust-section">
      <h2>
        Where Every Project Begins With <span className="trust">Trust</span> &
        Ends In <span className="success">Success</span>
      </h2>
 
      <div className="review-cards">
        {[
          {
            logo: FiverrLogo,
            alt: "Fiverr",
            url: "https://www.fiverr.com/bonyp09?public_mode=true",
          },
          {
            logo: UpworkLogo,
            alt: "Upwork",
            url: "https://www.upwork.com/freelancers/~01d5ca863b5b54f537?mp_source=share",
          },
          {
            logo: PeoplePerHourLogo,
            alt: "PeoplePerHour",
            url: "https://pph.me/deeppatel23",
          },
        ].map(({ logo, alt, url }, index) => (
          <div key={index} className="review-card">
            <img src={logo} alt={alt} className="platform-logo" />
            <p className="rating">5/5</p>
            <div className="stars">
              {[...Array(5)].map((_, i) => (
                <img key={i} src={StarIcon} alt="star" />
              ))}
            </div>
            <a href={url} target="_blank" rel="noopener noreferrer">
              <button className="read-reviews">Read Reviews</button>
            </a>
          </div>
        ))}
      </div>
 
      {/* Slider for client reviews */}
      <Slider {...sliderSettings}>
        {testimonials.map((testimonial) => (
          <div key={testimonial.id} className="slide-wrapper">
            <div className="client-review-card">
              <div className="client-header">
                <img
                  src={testimonial.image_url || ClientAvatar}
                  alt={testimonial.name || "client"}
                  className="client-avatar"
                />
                <div>
                  <strong>{testimonial.name}</strong>
                  {testimonial.country && (
                    <div className="client-country">{testimonial.country}</div>
                  )}
                </div>
              </div>
 
              <p className="client-review-text">{testimonial.text}</p>
            </div>
          </div>
        ))}
      </Slider>
    </section>
  );
};

export default TrustSection;